import { GeneriekBerichtOnderwerp } from "@/entities/bericht";

export const onderwerpLabelMap: Record<GeneriekBerichtOnderwerp, string> = {
    Algemeen: "algemeen",
    BetrokkenTreinen: "betrokken treinen",
    Faciliteiten: "faciliteiten",
    FaciliteitenLandelijk: "landelijke faciliteiten",
    Opstartplan: "opstartplan",
    VSM: "VSM",
    TVV: "treinvervangend vervoer",
};
